<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <!-- <div > -->
                <div class="hidden">
                <a-form-item label="ID主键" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入ID主键" />
                </a-form-item><a-form-item label="项目ID" name="projectId">
                    <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                </a-form-item><a-form-item label="分类ID" name="classification">
                    <a-input v-model:value="form.classification" placeholder="请输入分类ID" />
                </a-form-item><a-form-item label="项目负责人类型（项目负责人信息，课题负责人信息，申报单位项目负责人，合作单位项目负责人）" name="leaderType">
                    <a-input v-model:value="form.leaderType" placeholder="请输入项目负责人类型（项目负责人信息，课题负责人信息，申报单位项目负责人，合作单位项目负责人）" />
                </a-form-item>
            </div>

            <a-row :gutter="20">

                <a-col :span="24">
                    <a-form-item label="开始时间" name="startTime">
                        <date-picker v-model:value="form.startTime" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="结束时间" name="endTime">
                        <date-picker v-model:value="form.endTime"  :start="form.startDate"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="实施内容和目标（承担单位实施内容和目标）" name="contentObjectives">
                        <a-textarea v-model:value="form.contentObjectives" placeholder="请输入实施内容和目标（承担单位实施内容和目标）" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="合作(协作)单位实施内容和目标" name="collaborateContentObjectives">
                        <a-textarea v-model:value="form.collaborateContentObjectives" placeholder="请输入合作(协作)单位实施内容和目标" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import store from '@/store';
import {projectImplementation} from "@/api/TechnologieprojekteApply";

export default {
    name: "分阶段具体实施目标",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            form: {
                    id: null,
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                    leaderType: null,
                    startTime: null,
                    endTime: null,
                    contentObjectives: null,
                    collaborateContentObjectives: null,
                },
                rules: {
                    id: [],
                    projectId: [],
                    classification: [],
                    leaderType: [],
                    startTime: [dataCheck.required({})],
                    endTime: [dataCheck.required({})],
                    contentObjectives: [dataCheck.required({})],
                    collaborateContentObjectives: [dataCheck.required({})],
                },

        }
    },
    
    computed: {
            submitUrl() {
                return projectImplementation.saveOrUpdate
            },
        },
    mounted() {
    },
    methods: {
        postForm(e,m){
            setTimeout(() => {
                this.form.projectId = e,
                this.form.classification = m
            }, 50);
        }
    },
}
</script>
<style scoped lang="less">
</style>
